import request from '@/axios'
import type {
  UserLoginType,
  UserInfo,
  UserLoginResp,
  RegisterUserType,
  ModifyPasswordTypeType
} from './types'

interface RoleParams {
  tel_phone: string
}

export const loginApi = (data: UserLoginType): Promise<IResponse<UserLoginResp>> => {
  return request.post({ url: '/v1/user/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/v1/user/logOut' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserInfo[]
      total: number
    }
  }>({ url: '/v1/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/v1/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/v1/role/list2', params })
}

export const registerApi = (data: RegisterUserType): Promise<IResponse<UserLoginResp>> => {
  return request.post({ url: '/v1/user/register', data })
}

export const userInfoApi = (): Promise<IResponse<UserLoginResp>> => {
  return request.get({ url: '/v1/user/userInfo' })
}

export const modifyPasswordApi = (
  data: ModifyPasswordTypeType
): Promise<IResponse<UserLoginResp>> => {
  return request.post({ url: '/v1/user/modify_password', data })
}
